export const SystemThemeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_97_432)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.67797 0.645127C5.75807 0.565022 5.86671 0.52002 5.98 0.52002C7.566 0.52002 9.08704 1.15005 10.2085 2.27152C11.33 3.39299 11.96 4.91402 11.96 6.50002C11.96 8.08602 11.33 9.60706 10.2085 10.7285C9.08704 11.85 7.566 12.48 5.98 12.48C5.86671 12.48 5.75807 12.435 5.67797 12.355C5.59786 12.2748 5.55286 12.1662 5.55286 12.0529V0.947162C5.55286 0.833877 5.59786 0.725232 5.67797 0.645127ZM0.640714 5.8593C0.286857 5.8593 0 6.14617 0 6.50002C0 6.85387 0.286857 7.14073 0.640714 7.14073H1.495C1.84885 7.14073 2.13571 6.85387 2.13571 6.50002C2.13571 6.14617 1.84885 5.8593 1.495 5.8593H0.640714ZM1.75149 2.27151C2.0017 2.02129 2.40738 2.02129 2.6576 2.27151L3.39285 3.00676C3.64306 3.25697 3.64306 3.66265 3.39285 3.91287C3.14263 4.16308 2.73695 4.16308 2.48674 3.91287L1.75149 3.17762C1.50127 2.9274 1.50127 2.52172 1.75149 2.27151ZM3.39285 9.99311C3.64306 9.74289 3.64306 9.33727 3.39285 9.08705C3.14263 8.83681 2.73695 8.83681 2.48674 9.08705L1.75149 9.82225C1.50127 10.0725 1.50127 10.4782 1.75149 10.7284C2.0017 10.9786 2.40738 10.9786 2.6576 10.7284L3.39285 9.99311Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_97_432">
          <rect
            width="11.96"
            height="11.96"
            fill="currentColor"
            transform="translate(0 0.52002)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
